import { Chart } from '@frontend/chart/types';

import { formatChartSeriesName } from './format-chart-series-name';

export interface ChartListItem {
    key: string;
    name: string;
    value: number;
}

export const toChartListItems = (chart: Chart, unknownLabel: string): ChartListItem[] => {
    const items: ChartListItem[] = [];

    for (const series of chart.series) {
        const name = formatChartSeriesName(series.name, unknownLabel);
        if (!name) {
            continue;
        }

        const value = series.data.reduce((sum, point) => sum + point.value, 0);
        if (value === 0) {
            continue;
        }

        items.push({ key: series.name ?? name, name, value });
    }

    return items;
};
